import React from 'react'
import classes from './Portfolio.module.css'
import { NavLink } from 'react-router-dom'
import MetaTags from 'react-meta-tags';


function Portfolio(props) {
  return (
    <div className={classes.container}>
    <MetaTags>
      <title>Portfolio</title>
      <meta name="description" content="Some description." />
      <meta property="og:title" content="MyApp" />
      <meta property="og:image" content="path/to/image.jpg" />
    </MetaTags>        
        <div className={classes.header}>
            <h1>Portfolio<span className={classes.dot}></span></h1>
            <li onClick={props.Onclose}><a href="#"><NavLink to="/"><img className={classes.preview} src={require("../img/icons/home.png")} alt="" /></NavLink></a></li>
        </div>
        <div className={classes.lines}></div>
        <div className={classes.content}>
            <div className={classes.categoryNode}>
                <p>Node js</p>
            </div>
            <div className={classes.nodeSection}>
                <div className={classes.projectImg}>
                   <a href="https://exed.in/api/v1/user"><img className={classes.preview} src={require("../img/projects/edex.png")} alt="" /></a>
                </div>
                <div className={classes.projectTitle}>
                    <p>Edex e-commerce Strore</p>
                </div>
                <div className={classes.Detail}>
                    <a href="https://github.com/ADARSHKM123/edex" target="_blank">Details <span>-</span></a>
                </div>
            </div>

            <hr className={classes.underline}/>

            <div className={classes.nodeSection}>
                <div className={classes.projectImg}>
                   <a href="https://eyelids.in/"><img className={classes.preview} src={require("../img/projects/autumn.png")} alt="" /></a>
                </div>
                <div className={classes.projectTitle}>
                    <p>Tour Booking Site</p>
                </div>
                <div className={classes.Detail}>
                    <a href="https://github.com/ADARSHKM123/Autumn" target="_blank">Details <span>-</span></a>
                </div>
            </div>

            <hr className={classes.underline}/>
            <div className={classes.categoryFrame}>
                <p>React JS</p>
            </div>
            <div className={classes.frameSection}>
                <div className={classes.projectImg}>
                   <a href="https://ferrago-latest.web.app/"><img className={classes.preview} src={require("../img/projects/Ferrago.png")} alt="" /></a>
                </div>
                <div className={classes.projectTitle}>
                    <p>Food Ordering App</p>
                </div>
                <div className={classes.Detail}>
                    <a href="https://github.com/ADARSHKM123/ferrago" target="_blank">Details <span>-</span></a>
                </div>
            </div>
            <hr className={classes.underline}/>
            <div className={classes.frameSection}>
                <div className={classes.projectImg}>
                   <a href="https://adarsh-expense-tracker.netlify.app/"><img className={classes.preview} src={require("../img/projects/Expense.png")} alt="" /></a>
                </div>
                <div className={classes.projectTitle}>
                    <p>Expense Tracker</p>
                </div>
                <div className={classes.Detail}>
                    <a href="https://github.com/ADARSHKM123/Expense-tracker" target="_blank">Details <span>-</span></a>
                </div>
            </div>
            <hr className={classes.underline}/>
            
            <div className={classes.categoryFrame}>
                <p>Web Design</p>
            </div>
            <div className={classes.frameSection}>
                <div className={classes.projectImg}>
                   <a href="https://adarsh-online-banking.netlify.app/"><img className={classes.preview} src={require("../img/projects/Bank (1).png")} alt="" /></a>
                </div>
                <div className={classes.projectTitle}>
                    <p>Online Banking App</p>
                </div>
                <div className={classes.Detail}>
                    <a href="https://github.com/ADARSHKM123/Bank-app/tree/master" target="_blank">Details <span>-</span></a>
                </div>
            </div>
            <hr className={classes.underline}/>

            <div className={classes.frameSection}>
                <div className={classes.projectImg}>
                   <a href="https://game-adarsh.netlify.app/"><img className={classes.preview} src={require("../img/projects/game.png")} alt="" /></a>
                </div>
                <div className={classes.projectTitle}>
                    <p>Dice Game</p>
                </div>
                <div className={classes.Detail}>
                    <a href="https://github.com/ADARSHKM123/Pig-game/tree/main/starter" target="_blank">Details <span>-</span></a>
                </div>
            </div>
            <hr className={classes.underline}/>

            <div className={classes.frameSection}>
                <div className={classes.projectImg}>
                   <a href="https://adarsh-mapty.netlify.app/"><img className={classes.preview} src={require("../img/projects/map.png")} alt="" /></a>
                </div>
                <div className={classes.projectTitle}>
                    <p>Mapty App</p>
                </div>
                <div className={classes.Detail}>
                    <a href="https://github.com/ADARSHKM123/mapty" target="_blank">Details <span>-</span></a>
                </div>
            </div>
            <hr className={classes.underline}/>

            <div className={classes.frameSection}>
                <div className={classes.projectImg}>
                   <a href="https://adarsh-guess-my-number.netlify.app/"><img className={classes.preview} src={require("../img/projects/dice-game.png")} alt="" /></a>
                </div>
                <div className={classes.projectTitle}>
                    <p>Guess My Number Game</p>
                </div>
                <div className={classes.Detail}>
                    <a href="https://github.com/ADARSHKM123/Guessing-game" target="_blank">Details <span>-</span></a>
                </div>
            </div>
            <hr className={classes.underline}/>

            <div className={classes.frameSection}>
                <div className={classes.projectImg}>
                   <a href="https://omnifood-adarsh.netlify.app/"><img className={classes.preview} src={require("../img/projects/web-design.png")} alt="" /></a>
                </div>
                <div className={classes.projectTitle}>
                    <p>OmniFood Web Design</p>
                </div>
                <div className={classes.Detail}>
                    <a href="https://github.com/ADARSHKM123/Omnifood-Website" target="_blank">Details <span>-</span></a>
                </div>
            </div>
            <hr className={classes.underline}/>
            <div className={classes.blank}></div>
        </div>
    </div>
  )
}

export default Portfolio